import { Component } from "react";
import { Col, Row } from "reactstrap";
import ImageViwer from "./imageViwer";

class Gallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageOpen:false,
            currImg:0,
            hostName:process.env.REACT_APP_SERVER_URL

        }
    }
    handleImageClick = event => {
        this.setState({
          imageOpen: true
        });
      };

      handleImageClose = event => {
        this.setState({
          imageOpen: false
        });
      };

      gotoNextImg= event => {
        this.setState((prevState, props) => ({
          currImg: prevState.currImg + 1
      })); 
      };
      gotoPrevImg= event => {
        this.setState((prevState, props) => ({
          currImg: prevState.currImg - 1
      })); 
      };

      changeCurrentImage = e =>{
        this.setState({
          currImg: e
        });        
      }
    render() { 
      const nbrImages = this.props.nbrImages;
        const IMG_SET = [];
        const HOST_NAME = this.state.hostName
          for (let i = 0; i <nbrImages; i++) {
            IMG_SET.push(
              {src : `${HOST_NAME}/api/announces/${this.props.galleryId}/avatar/${i}`})
          }

        return ( 
            <>
            <ImageViwer
                isOpen={this.state.imageOpen}
                currImg={this.state.currImg}
                imgs={IMG_SET}
                onClose={() => this.handleImageClose()}
                onClickNext={() => this.gotoNextImg()}
                onClickPrev={() => {
                  this.gotoPrevImg();
                }}
                onClickThumbnail={(e) => {
                  this.changeCurrentImage(e);
                }}
                backdropCloseable={true}
              />
              <Row className="pr-3">
                  <Col
                    sm="12"
                    id="detail-image-big"
                    onClick={() => this.handleImageClick()}
                  >
                     {nbrImages > 0 && 
                     <img
                        id="detail-image-big"
                        src={this.props.img}
                        alt="alt"
                        onClick={() => this.handleImageClick()}
                      />}
                      {nbrImages === 0 && 
                      <img
                        id="detail-image-big"
                        src={`/imgs/announces/no-image.png`}
                        alt="alt"
                      />}
                    )
                    <img
                      src="/imgs/announces/focus.svg"                        
                      id="focus"
                      alt="focus"
                    />
                  </Col>
                  <Col
                    className="carImgs"
                    sm="4"
                    id="detail-image-small"
                    onClick={() => this.handleImageClick()}
                  >
                     {nbrImages > 1 && 
                     <img
                        id="detail-image-small"
                        src={`${HOST_NAME}/api/announces/${this.props.galleryId}/avatar/1`}
                        alt="alt"
                      />}

                     {nbrImages <= 1 && 
                     <img
                        id="detail-image-small"
                        src={`/imgs/announces/no-image.png`}
                        alt="alt"
                      />}

                  </Col>
                  <Col
                    className="carImgs"
                    sm="4"
                    id="detail-image-small"
                    onClick={() => this.handleImageClick()}
                  >
                      {nbrImages > 2 && 
                      <img
                        id="detail-image-small"
                        src={`${HOST_NAME}/api/announces/${this.props.galleryId}/avatar/2`}
                        alt="alt"
                      />}
                      {nbrImages <= 2 && 
                     <img
                        id="detail-image-small"
                        src={`/imgs/announces/no-image.png`}
                        alt="alt"
                      />}
                  </Col>
                  <Col
                    className="carImgs"
                    sm="4"
                    id="detail-image-small"
                    onClick={() => this.handleImageClick()}
                  >
                    {this.props.nbrImages-4 >0 && <>
                    <div className="more-images"></div>
                    <span className="img-number">+{this.props.nbrImages-4}</span>
                    </>
                    }
                    { nbrImages > 3 &&  <img
                        id="detail-image-small"
                        src={`${HOST_NAME}/api/announces/${this.props.galleryId}/avatar/3`}
                        alt="alt"
                      />
                      }
                     { nbrImages <= 3 &&  <img
                        id="detail-image-small"
                        src={`/imgs/announces/no-image.png`}
                        alt="alt"
                      />
                      }
                      
                  </Col>
                  </Row>
          </>
         );
    }
}
 
export default Gallery;